module.exports = __webpack_public_path__ + "img/pin_vms.3fcd29b0.svg";